import { DataLoader } from 'src/app/services/data-loader/data-loader';

export const createCase5 = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        // wait
        await new Promise((resolve) => setTimeout(resolve, 1000));
        this.emitter.emit({
            data: [
                {
                    date: '2025-09-01',
                    mau: 266329,
                    new_users: 16418,
                    dates: 1,
                    avg_monthly_dau: 266329,
                },
            ],
            queryContext: { datasourceColumns: [], settings: {} },
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
